"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.imageFragment = void 0;
exports.imageFragment = `
fragment image on Image {
  url
  altText
  variants {
    url
    width
  }
}
`;
//# sourceMappingURL=image.js.map